import { Injectable } from '@angular/core';
@Injectable()
export class Maintenance {
    maintenanceOutage_prior: string;
    maintenanceOutage_prior_flag: boolean;
    maintenanceOutage_during: string;
    maintenanceOutage_during_flag: boolean;
}
